<template>
	<Accordion
		:open="true"
		:title="$I18n.trans('highlights.audio_detection.tagging.title')"
		icon="c-info"
		:icon-hint="$I18n.trans('highlights.audio_detection.tagging.hint')"
	>
		<HighlightDetectionWidget />
	</Accordion>
</template>
<script>
import Accordion from '@components/accordion/Accordion';
import HighlightDetectionWidget from '@js/one/components/highlights/HighlightDetectionWidget';

export default {
	name:       'HighlightSection',
	components: { Accordion, HighlightDetectionWidget },
};
</script>
